:root {
  --bg: #faf8f5;
  --panel: #ffffff;
  --panel-2: #f3efe9;
  --line: #e4ddd3;
  --text: #1d1915;
  --muted: #6f665c;
  --accent: #c8582a;
  --accent-ink: #ffffff;
  --ok: #2f7d4f;
  --warn: #a8641a;
  --bad: #b3372f;
  --mono: ui-monospace, "Cascadia Code", "SF Mono", Menlo, Consolas, monospace;
  --sans: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  color-scheme: light;
}
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --bg: #14110f; --panel: #1c1815; --panel-2: #24201c; --line: #352f29; --text: #efe9e1; --muted: #a39a8f;
    --accent: #e8743b; --accent-ink: #14110f; --ok: #5bbf84; --warn: #e0a24f; --bad: #ef6b60; color-scheme: dark;
  }
}
:root[data-theme="dark"] {
  --bg: #14110f; --panel: #1c1815; --panel-2: #24201c; --line: #352f29; --text: #efe9e1; --muted: #a39a8f;
  --accent: #e8743b; --accent-ink: #14110f; --ok: #5bbf84; --warn: #e0a24f; --bad: #ef6b60; color-scheme: dark;
}

* { box-sizing: border-box; }
html, body { margin: 0; background: var(--bg); color: var(--text); font: 15px/1.5 var(--sans); }
a { color: var(--accent); text-decoration: none; }
a:hover { text-decoration: underline; }
code, pre, .mono { font-family: var(--mono); font-size: 13px; }
h1 { font-size: 22px; margin: 0 0 4px; letter-spacing: -0.01em; }
h2 { font-size: 16px; margin: 24px 0 10px; }
p { margin: 0 0 12px; }
.muted { color: var(--muted); }

.shell { display: grid; grid-template-columns: 232px 1fr; min-height: 100vh; }
.side { border-right: 1px solid var(--line); padding: 18px 12px; background: var(--panel); position: sticky; top: 0; height: 100vh; overflow-y: auto; }
.brand { display: flex; gap: 10px; align-items: center; font-weight: 700; padding: 0 8px 16px; }
.brand img { width: 26px; height: 26px; }
.nav-label { font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em; color: var(--muted); margin: 16px 8px 6px; }
.nav a { display: block; padding: 7px 10px; border-radius: 8px; color: var(--text); }
.nav a:hover { background: var(--panel-2); text-decoration: none; }
.nav a.active { background: var(--panel-2); color: var(--accent); font-weight: 600; }
.side-foot { margin-top: 24px; padding: 10px 8px; border-top: 1px solid var(--line); font-size: 13px; }
.main { padding: 28px 32px 64px; max-width: 1180px; width: 100%; }
.page-head { display: flex; justify-content: space-between; align-items: flex-end; gap: 16px; margin-bottom: 20px; flex-wrap: wrap; }

.grid { display: grid; gap: 14px; grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)); }
.card { background: var(--panel); border: 1px solid var(--line); border-radius: 12px; padding: 16px; }
.stat .label { font-size: 12px; color: var(--muted); }
.stat .value { font-size: 26px; font-weight: 650; letter-spacing: -0.02em; margin-top: 2px; }
.stat .sub { font-size: 12px; color: var(--muted); }
.meter { height: 8px; background: var(--panel-2); border-radius: 99px; overflow: hidden; margin: 10px 0 6px; }
.meter > i { display: block; height: 100%; background: var(--accent); border-radius: 99px; }

.table-wrap { overflow-x: auto; background: var(--panel); border: 1px solid var(--line); border-radius: 12px; }
table { width: 100%; border-collapse: collapse; font-size: 14px; }
th, td { text-align: left; padding: 10px 14px; border-bottom: 1px solid var(--line); white-space: nowrap; }
th { font-size: 12px; color: var(--muted); font-weight: 600; background: var(--panel-2); }
tr:last-child td { border-bottom: 0; }
td.wrap { white-space: normal; min-width: 240px; }

.btn { display: inline-flex; gap: 6px; align-items: center; border: 1px solid var(--line); background: var(--panel); color: var(--text); padding: 7px 12px; border-radius: 8px; font: inherit; font-size: 14px; cursor: pointer; }
.btn:hover { border-color: var(--muted); }
.btn.primary { background: var(--accent); border-color: var(--accent); color: var(--accent-ink); font-weight: 600; }
.btn.danger { color: var(--bad); }
.btn:disabled { opacity: 0.5; cursor: default; }
input, select, textarea { font: inherit; color: var(--text); background: var(--panel); border: 1px solid var(--line); border-radius: 8px; padding: 8px 10px; width: 100%; }
textarea { min-height: 96px; resize: vertical; }
label { display: block; font-size: 13px; color: var(--muted); margin: 12px 0 4px; }
.row { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.form { max-width: 560px; }

.pill { display: inline-block; padding: 1px 8px; border-radius: 99px; font-size: 12px; border: 1px solid var(--line); background: var(--panel-2); }
.pill.ok { color: var(--ok); } .pill.bad { color: var(--bad); } .pill.warn { color: var(--warn); } .pill.accent { color: var(--accent); }
.error { color: var(--bad); background: color-mix(in srgb, var(--bad) 10%, transparent); border: 1px solid color-mix(in srgb, var(--bad) 30%, transparent); padding: 10px 12px; border-radius: 8px; margin: 12px 0; }
.notice { background: var(--panel-2); border: 1px solid var(--line); padding: 10px 12px; border-radius: 8px; margin: 12px 0; }

.center { min-height: 100vh; display: grid; place-items: center; padding: 16px; }
.auth-card { width: 100%; max-width: 400px; }
.code { font-family: var(--mono); font-size: 28px; letter-spacing: 0.12em; text-align: center; padding: 14px; background: var(--panel-2); border-radius: 10px; }

.log { background: #0f0d0b; color: #e8e2d8; border-radius: 12px; padding: 14px; font-family: var(--mono); font-size: 13px; line-height: 1.45; max-height: 60vh; overflow: auto; white-space: pre-wrap; word-break: break-word; }
.log .cmd { color: #e8743b; } .log .err { color: #ef6b60; } .log .sys { color: #8f877d; }

.chat { display: flex; flex-direction: column; gap: 10px; }
.msg { padding: 10px 14px; border-radius: 10px; border: 1px solid var(--line); background: var(--panel); white-space: pre-wrap; word-break: break-word; }
.msg.user { background: var(--panel-2); }
.msg .who { font-size: 12px; color: var(--muted); margin-bottom: 4px; }
.msg.tool { font-family: var(--mono); font-size: 13px; color: var(--muted); }
.composer { position: sticky; bottom: 0; background: var(--bg); padding: 12px 0; display: flex; gap: 8px; }

.bars { display: flex; align-items: flex-end; gap: 3px; height: 120px; padding-top: 8px; }
.bars i { flex: 1; background: var(--accent); border-radius: 3px 3px 0 0; min-height: 2px; opacity: 0.85; }

.menu-btn { display: none; }
@media (max-width: 820px) {
  .shell { grid-template-columns: 1fr; }
  .side { position: fixed; inset: 0 30% 0 0; z-index: 10; transform: translateX(-100%); transition: transform 0.2s; height: 100vh; }
  .side.open { transform: none; box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.4); }
  .main { padding: 16px 16px 64px; }
  .menu-btn { display: inline-flex; margin-bottom: 12px; }
}

.social { display: flex; flex-direction: column; gap: 8px; margin-top: 12px; }
.social-btn { justify-content: center; width: 100%; padding: 9px 12px; }
.divider { display: flex; align-items: center; gap: 10px; margin: 16px 0 4px; color: var(--muted); font-size: 13px; }
.divider::before, .divider::after { content: ''; flex: 1; border-top: 1px solid var(--line); }

/* /a/:slug: a published artifact, full height under a thin bar */
.artifact-view { display: flex; flex-direction: column; height: 100vh; }
.artifact-bar { display: flex; gap: 14px; align-items: center; padding: 8px 16px; border-bottom: 1px solid var(--line); background: var(--panel); flex-wrap: wrap; }
.artifact-bar .brand { padding: 0; }
.artifact-bar .brand img { width: 20px; height: 20px; }
.artifact-title { overflow-wrap: anywhere; }
.artifact-frame { flex: 1; width: 100%; border: 0; background: #fff; }
